export interface SMSMessage {
  id: string;
  sender: 'contact' | 'player';
  kab: string;
  fr: string;
  time: string;
}

export interface SMSDiscussion {
  id: string;
  title: string;
  contactName: string;
  contactRole: string;
  avatar: string;
  avatarBg: string;
  themeTag: string;
  contextDesc: string;
  messages: SMSMessage[];
}

export const SMS_DISCUSSIONS: SMSDiscussion[] = [
  {
    id: 'sms_yemma_dinner',
    title: 'Awal d Yemma',
    contactName: 'Yemma (Maman)',
    contactRole: 'Famille & Foyer',
    avatar: '👩‍🍳',
    avatarBg: 'bg-rose-100 border-rose-300 text-rose-900',
    themeTag: 'Famille & Quotidien',
    contextDesc: 'Échange spontané avec votre mère pour donner de vos nouvelles et organiser le dîner.',
    messages: [
      {
        id: 'm1_1',
        sender: 'contact',
        kab: 'Azul a mmi, labas ?',
        fr: 'Salut mon fils, tu vas bien ?',
        time: '17:15',
      },
      {
        id: 'm1_2',
        sender: 'player',
        kab: 'Azul yemma, labas tanemmirt ! I kemm ?',
        fr: 'Salut maman, ça va merci ! Et toi ?',
        time: '17:16',
      },
      {
        id: 'm1_3',
        sender: 'contact',
        kab: 'Labas lḥemdulilah ! Melmi ara d-tawḍeḍ ?',
        fr: 'Ça va dieu merci ! Tu arrives à quelle heure ?',
        time: '17:18',
      },
      {
        id: 'm1_4',
        sender: 'player',
        kab: 'Ad d-awḍeɣ ɣer ssetta, qbel imensi.',
        fr: 'J\'arrive vers 18h, avant le dîner.',
        time: '17:20',
      },
      {
        id: 'm1_5',
        sender: 'contact',
        kab: 'Aha ihi, heggaɣ-d seksu s uyaziḍ !',
        fr: 'Super, j\'ai préparé un bon couscous au poulet !',
        time: '17:22',
      },
      {
        id: 'm1_6',
        sender: 'player',
        kab: 'Igerrez yemma ! Ad d-aɣeɣ aɣrum deg ubrid.',
        fr: 'Super maman ! J\'achète du pain en route.',
        time: '17:24',
      },
      {
        id: 'm1_7',
        sender: 'contact',
        kab: 'A k-iḥrez Rebbi a mmi, ḥader iman-ik !',
        fr: 'Que Dieu te garde mon fils, fais attention à toi !',
        time: '17:25',
      },
      {
        id: 'm1_8',
        sender: 'player',
        kab: 'Ulac aɣilif yemma, ar tmeddit !',
        fr: 'T\'inquiète pas maman, à ce soir !',
        time: '17:26',
      },
    ],
  },
  {
    id: 'sms_youcef_cafe',
    title: 'Tafsut d Youcef',
    contactName: 'Youcef (L\'Ami)',
    contactRole: 'Ami du village',
    avatar: '☕',
    avatarBg: 'bg-amber-100 border-amber-300 text-amber-900',
    themeTag: 'Sortie & Rendez-vous',
    contextDesc: 'Un ami d\'enfance vous propose de vous retrouver rapidement au café.',
    messages: [
      {
        id: 'm2_1',
        sender: 'contact',
        kab: 'Azul a gma ! Anda-k ?',
        fr: 'Salut mon frère ! T\'es où ?',
        time: '15:40',
      },
      {
        id: 'm2_2',
        sender: 'player',
        kab: 'Azul Youcef ! Deg wexxam kan, ur xeddmeɣ ara.',
        fr: 'Salut Youcef ! À la maison tranquille, je bosse pas.',
        time: '15:42',
      },
      {
        id: 'm2_3',
        sender: 'contact',
        kab: 'Ad nṛuḥ ad nsew lqahwa ?',
        fr: 'On va boire un café ?',
        time: '15:43',
      },
      {
        id: 'm2_4',
        sender: 'player',
        kab: 'Ih s lferḥ ! Melmi ara nemlil ?',
        fr: 'Carrément avec plaisir ! On se voit quand ?',
        time: '15:45',
      },
      {
        id: 'm2_5',
        sender: 'contact',
        kab: 'Deg leṛbɛa zdat la cafétéria n l-ville, ça te va ?',
        fr: 'À 16h devant la cafétéria du centre-ville, ça te va ?',
        time: '15:47',
      },
      {
        id: 'm2_6',
        sender: 'player',
        kab: 'Igerrez, ad nqeṣṣer cwiṭ !',
        fr: 'Nickel, on va papoter un peu !',
        time: '15:49',
      },
      {
        id: 'm2_7',
        sender: 'contact',
        kab: 'Awi-d aselkim yid-k ma tzemreḍ !',
        fr: 'Prends ton ordi si tu peux !',
        time: '15:50',
      },
      {
        id: 'm2_8',
        sender: 'player',
        kab: 'Ih ulac aɣilif, d tusdidin kan ad d-awḍeɣ !',
        fr: 'Oui pas de souci, j\'arrive dans quelques minutes !',
        time: '15:52',
      },
    ],
  },
  {
    id: 'sms_fadma_market',
    title: 'Ssuq d Na Fadma',
    contactName: 'Na Fadma (La Tante)',
    contactRole: 'Famille & Commissions',
    avatar: '🧺',
    avatarBg: 'bg-emerald-100 border-emerald-300 text-emerald-900',
    themeTag: 'Marché & Commissions',
    contextDesc: 'Votre tante vous demande quelques courses indispensables pendant que vous êtes au marché.',
    messages: [
      {
        id: 'm3_1',
        sender: 'contact',
        kab: 'Azul a mmi ! Telliḍ deg ssuq ?',
        fr: 'Salut mon garçon ! T\'es au marché ?',
        time: '09:30',
      },
      {
        id: 'm3_2',
        sender: 'player',
        kab: 'Azul xalti ! Ih, tura kan i d-kecmeɣ.',
        fr: 'Salut la tante ! Oui, je viens tout juste d\'entrer.',
        time: '09:32',
      },
      {
        id: 'm3_3',
        sender: 'contact',
        kab: 'Aɣ-d sin kilu n tbaṭaṭa d yiwen n lkru ma ulac aɣilif.',
        fr: 'Prends-moi 2 kilos de patates et un chou s\'il te plaît.',
        time: '09:34',
      },
      {
        id: 'm3_4',
        sender: 'player',
        kab: 'Ih d ayen isehlen ! D acu nniḍen ?',
        fr: 'Oui bien sûr avec plaisir ! Quoi d\'autre ?',
        time: '09:36',
      },
      {
        id: 'm3_5',
        sender: 'contact',
        kab: 'Ma tufaḍ zzit uzemmur yelhan, aɣ-d yiwet tqeṛɛet.',
        fr: 'Si tu trouves de la bonne huile d\'olive, prends une bouteille.',
        time: '09:38',
      },
      {
        id: 'm3_6',
        sender: 'player',
        kab: 'Ẓriɣ yiwen yelhan, ad s-ssutreɣ ssuma.',
        fr: 'J\'en connais un très bon, je vais lui demander le prix.',
        time: '09:40',
      },
      {
        id: 'm3_7',
        sender: 'contact',
        kab: 'Tanemmirt a mmi, ad k-ixlef Rebbi !',
        fr: 'Merci mon garçon, que Dieu te le rende !',
        time: '09:41',
      },
      {
        id: 'm3_8',
        sender: 'player',
        kab: 'Ulac aɣilif a xalti, d lwağeb !',
        fr: 'De rien la tante, c\'est normal !',
        time: '09:43',
      },
    ],
  },
  {
    id: 'sms_meziane_taxi',
    title: 'Abrid d Meziane',
    contactName: 'Meziane (Chauffeur Taxi)',
    contactRole: 'Transport & Voyage',
    avatar: '🚕',
    avatarBg: 'bg-yellow-100 border-yellow-300 text-yellow-900',
    themeTag: 'Transport & Trajet',
    contextDesc: 'Confirmation rapide d\'un trajet en taxi pour descendre en ville.',
    messages: [
      {
        id: 'm4_1',
        sender: 'contact',
        kab: 'Azul a gma ! Mazal tebɣiḍ ṭaksi ɣer Tizi ?',
        fr: 'Salut l\'ami ! T\'as toujours besoin d\'un taxi pour Tizi ?',
        time: '19:10',
      },
      {
        id: 'm4_2',
        sender: 'player',
        kab: 'Azul Meziane ! Ih, azekka ṣbeḥ ilaq ad ṛuḥeɣ.',
        fr: 'Salut Meziane ! Oui, demain matin je dois descendre.',
        time: '19:12',
      },
      {
        id: 'm4_3',
        sender: 'contact',
        kab: 'Melmi ara nṛuḥ ? Nekkini heggaɣ takeṛṛust.',
        fr: 'On part à quelle heure ? La voiture est prête.',
        time: '19:14',
      },
      {
        id: 'm4_4',
        sender: 'player',
        kab: 'Deg ttmenya zdat wexxam.',
        fr: 'À 8 heures devant chez moi.',
        time: '19:16',
      },
      {
        id: 'm4_5',
        sender: 'contact',
        kab: 'Igerrez. Acḥal yid-wen ?',
        fr: 'Ça marche. Vous êtes combien ?',
        time: '19:17',
      },
      {
        id: 'm4_6',
        sender: 'player',
        kab: 'Nekk d gma kan, kolci ihegga.',
        fr: 'Juste moi et mon frère, tout est prêt.',
        time: '19:19',
      },
      {
        id: 'm4_7',
        sender: 'contact',
        kab: 'Ihi ad iliɣ din deg lweqt. Abrid yelha !',
        fr: 'Alors je serai là à l\'heure. La route est fluide !',
        time: '19:21',
      },
      {
        id: 'm4_8',
        sender: 'player',
        kab: 'Tanemmirt a Meziane, ar azekka inshallah !',
        fr: 'Merci Meziane, à demain inshallah !',
        time: '19:22',
      },
    ],
  },
  {
    id: 'sms_katia_hike',
    title: 'Tikli d Katia',
    contactName: 'Katia (Amie)',
    contactRole: 'Randonnée & Nature',
    avatar: '🏔️',
    avatarBg: 'bg-cyan-100 border-cyan-300 text-cyan-900',
    themeTag: 'Nature & Loisirs',
    contextDesc: 'Organisation d\'une randonnée vivifiante dans les hauteurs du Djurdjura.',
    messages: [
      {
        id: 'm5_1',
        sender: 'contact',
        kab: 'Azul ! Twalaḍ lḥal n wass-a ? Iṭij yeṣfa !',
        fr: 'Salut ! T\'as vu le temps aujourd\'hui ? Grand soleil !',
        time: '08:15',
      },
      {
        id: 'm5_2',
        sender: 'player',
        kab: 'Azul Katia ! Ih, lḥal igerrez nezzeh !',
        fr: 'Salut Katia ! Oui, le temps est magnifique !',
        time: '08:17',
      },
      {
        id: 'm5_3',
        sender: 'contact',
        kab: 'Ad nali ɣer Tala Guilef ad nḥewwes ?',
        fr: 'On monte à Tala Guilef se balader ?',
        time: '08:19',
      },
      {
        id: 'm5_4',
        sender: 'player',
        kab: 'D tikti yelhan ! Ad d-nawi aman d uɣrum.',
        fr: 'Trop bonne idée ! On prend de l\'eau et du pain.',
        time: '08:21',
      },
      {
        id: 'm5_5',
        sender: 'contact',
        kab: 'Hegg-d tisekkartin yelhan, yella cwiṭ wedfel !',
        fr: 'Prends de bonnes baskets, il reste un peu de neige !',
        time: '08:23',
      },
      {
        id: 'm5_6',
        sender: 'player',
        kab: 'Heggiɣ akk lqec n wedrar.',
        fr: 'J\'ai déjà préparé les habits pour la montagne.',
        time: '08:25',
      },
      {
        id: 'm5_7',
        sender: 'contact',
        kab: 'Yallah ad nṛuḥ, ad nɛeddi ɣef watmaten !',
        fr: 'Allez on y va, on passe prendre les cousins !',
        time: '08:26',
      },
      {
        id: 'm5_8',
        sender: 'player',
        kab: 'Abrid yelhan ihi, yallah ad nṛuḥ !',
        fr: 'Bonne route alors, en route !',
        time: '08:28',
      },
    ],
  },
  {
    id: 'sms_massi_football',
    title: 'Takurt d Massinissa',
    contactName: 'Massinissa (Le Pote)',
    contactRole: 'Football & Loisirs',
    avatar: '⚽',
    avatarBg: 'bg-emerald-100 border-emerald-300 text-emerald-900',
    themeTag: 'Loisirs & Sport',
    contextDesc: 'Organisation d\'un match de foot entre potes au stade du village ce soir.',
    messages: [
      {
        id: 'm6_1',
        sender: 'contact',
        kab: 'Azul a gma ! Telliḍ heggaḍ i lmatch n tmeddit ?',
        fr: 'Salut frérot ! T\'es prêt pour le match ce soir ?',
        time: '17:00',
      },
      {
        id: 'm6_2',
        sender: 'player',
        kab: 'Azul Massi ! Ih heggaɣ iman-iw, d acu n lweqt ?',
        fr: 'Salut Massi ! Oui je suis chaud, à quelle heure ?',
        time: '17:02',
      },
      {
        id: 'm6_3',
        sender: 'contact',
        kab: 'Deg ssetta deg terrain synthétique. Ur tettu ara takurt-ik !',
        fr: 'À 18h au terrain synthétique (foot à 5). Oublie pas ton ballon !',
        time: '17:04',
      },
      {
        id: 'm6_4',
        sender: 'player',
        kab: 'Ad tt-id-awiɣ yid-i. Acḥal yid-nneɣ ara yilin ?',
        fr: 'Je l\'emmène avec moi. On sera combien ?',
        time: '17:06',
      },
      {
        id: 'm6_5',
        sender: 'contact',
        kab: 'Nelli mraw yid-nneɣ, ad nexdem sin tegwrawin.',
        fr: 'On est dix en tout, on fera deux équipes.',
        time: '17:08',
      },
      {
        id: 'm6_6',
        sender: 'player',
        kab: 'Igerrez aṭas ! Ad d-awiɣ daɣen aman iṣemmaḍen.',
        fr: 'Trop bien ! Je ramène aussi de l\'eau fraîche.',
        time: '17:10',
      },
      {
        id: 'm6_7',
        sender: 'contact',
        kab: 'Tanemmirt a gma, ad k-raǧiɣ din !',
        fr: 'Merci frérot, je t\'attends là-bas !',
        time: '17:11',
      },
      {
        id: 'm6_8',
        sender: 'player',
        kab: 'Ar tura ihi, yallah !',
        fr: 'À tout de suite alors, c\'est parti !',
        time: '17:12',
      },
    ],
  },
  {
    id: 'sms_lmulud_garage',
    title: 'Takeṛṛust d Dda Lmulud',
    contactName: 'Dda Lmulud (Mécanicien)',
    contactRole: 'Garage & Entretien',
    avatar: '🔧',
    avatarBg: 'bg-amber-100 border-amber-300 text-amber-900',
    themeTag: 'Services & Garage',
    contextDesc: 'Prendre des nouvelles de la réparation de la voiture au garage du village.',
    messages: [
      {
        id: 'm7_1',
        sender: 'contact',
        kab: 'Azul a mmi ! Tekfa tkeṛṛust-ik deg lgaraj.',
        fr: 'Salut mon garçon ! Ta voiture est prête au garage.',
        time: '14:30',
      },
      {
        id: 'm7_2',
        sender: 'player',
        kab: 'Azul Dda Lmulud ! Tanemmirt, d acu i tt-yuɣen ?',
        fr: 'Salut Dda Lmulud ! Merci, c\'était quoi le souci ?',
        time: '14:32',
      },
      {
        id: 'm7_3',
        sender: 'contact',
        kab: 'D lbatri kan i nbeddel, tura tecɛel akken ilaq.',
        fr: 'Juste la batterie à changer, là elle démarre nickel.',
        time: '14:34',
      },
      {
        id: 'm7_4',
        sender: 'player',
        kab: 'Acḥal ara k-xellṣeɣ ma ulac aɣilif ?',
        fr: 'Combien je vous dois s\'il vous plaît ?',
        time: '14:36',
      },
      {
        id: 'm7_5',
        sender: 'contact',
        kab: 'Kraḍ alaf idinaren kan, as-d melmi tebɣiḍ.',
        fr: '3000 dinars seulement, passe quand tu veux.',
        time: '14:37',
      },
      {
        id: 'm7_6',
        sender: 'player',
        kab: 'Ad d-ɛeddiɣ ɣef rrebɛa n tmeddit ad tt-id-ṭṭfeɣ.',
        fr: 'Je passe vers 16h pour la récupérer.',
        time: '14:39',
      },
      {
        id: 'm7_7',
        sender: 'contact',
        kab: 'Qbel ma tɛeddiḍ siwel-iyi-d kan !',
        fr: 'Avant de passer passe-moi un coup de fil !',
        time: '14:40',
      },
      {
        id: 'm7_8',
        sender: 'player',
        kab: 'Ih d ayen isehlen, tanemmirt a Dda Lmulud !',
        fr: 'Oui sans souci, merci Dda Lmulud !',
        time: '14:42',
      },
    ],
  },
  {
    id: 'sms_lydia_birthday',
    title: 'Tameɣra d Lydia',
    contactName: 'Lydia (La Cousine)',
    contactRole: 'Fête & Surprise',
    avatar: '🎂',
    avatarBg: 'bg-purple-100 border-purple-300 text-purple-900',
    themeTag: 'Fête & Célébration',
    contextDesc: 'Préparation d\'une fête surprise et commande du gâteau d\'anniversaire.',
    messages: [
      {
        id: 'm8_1',
        sender: 'contact',
        kab: 'Azul ! Tufiḍ lgateau i l\'anniversaire n Dihya ?',
        fr: 'Salut ! T\'as trouvé le gâteau pour l\'anniversaire de Dihya ?',
        time: '16:15',
      },
      {
        id: 'm8_2',
        sender: 'player',
        kab: 'Azul Lydia ! Ih, ssutreɣ lgateau n cculaṭa iṣeḥḥan.',
        fr: 'Salut Lydia ! Oui, j\'ai commandé un super gâteau au chocolat.',
        time: '16:17',
      },
      {
        id: 'm8_3',
        sender: 'contact',
        kab: 'D ayen igerzen ! Melmi ara t-id-tawiḍ ?',
        fr: 'Génial ! Tu le récupères à quelle heure ?',
        time: '16:19',
      },
      {
        id: 'm8_4',
        sender: 'player',
        kab: 'Ad t-id-awiɣ deg lweqt n lexmsa qbel lḥefla.',
        fr: 'Je le prends vers 17h juste avant la fête.',
        time: '16:21',
      },
      {
        id: 'm8_5',
        sender: 'contact',
        kab: 'Tzemreḍ ad d-taɣeḍ tiwezzaɣin d yijelliden ?',
        fr: 'Tu peux acheter des bougies et des ballons ?',
        time: '16:23',
      },
      {
        id: 'm8_6',
        sender: 'player',
        kab: 'Heggiɣ akk leslaḥ-agi yakan, kkes aɣilif !',
        fr: 'J\'ai déjà tout acheté, t\'inquiète pas !',
        time: '16:25',
      },
      {
        id: 'm8_7',
        sender: 'contact',
        kab: 'Tanemmirt-ik a gma, ad d-tili d tameɣra ifazen !',
        fr: 'Merci beaucoup frérot, ça va être une fête géniale !',
        time: '16:26',
      },
      {
        id: 'm8_8',
        sender: 'player',
        kab: 'S tumert tameqrant, ar tmeddit inshallah !',
        fr: 'Avec grand plaisir, à tout à l\'heure inshallah !',
        time: '16:28',
      },
    ],
  },
  {
    id: 'sms_smail_tools',
    title: 'Allalen d Smail',
    contactName: 'Smail (Le Voisin)',
    contactRole: 'Bricolage & Entraide',
    avatar: '🔨',
    avatarBg: 'bg-blue-100 border-blue-300 text-blue-900',
    themeTag: 'Bricolage & Voisinage',
    contextDesc: 'Prêt d\'outils de bricolage et entraide amicale entre voisins.',
    messages: [
      {
        id: 'm9_1',
        sender: 'contact',
        kab: 'Azul a gma ! Tesɛiḍ tamsadit d lemceq deg wexxam ?',
        fr: 'Salut l\'ami ! T\'as une perceuse et une scie chez toi ?',
        time: '11:10',
      },
      {
        id: 'm9_2',
        sender: 'player',
        kab: 'Azul Smail ! Ih sɛiɣ akk leslaḥ n uxeddim, tebɣiḍ-ten ?',
        fr: 'Salut Smail ! Oui j\'ai tous les outils, tu en as besoin ?',
        time: '11:12',
      },
      {
        id: 'm9_3',
        sender: 'contact',
        kab: 'Bɣiɣ ad sbeddeɣ yiwet n ttabla deg tebḥirt.',
        fr: 'Je veux installer une table dans le jardin.',
        time: '11:14',
      },
      {
        id: 'm9_4',
        sender: 'player',
        kab: 'Awi-ten-id tura ma tebɣiḍ, rẓam tawwurt !',
        fr: 'Prends-les maintenant si tu veux, la porte est ouverte !',
        time: '11:16',
      },
      {
        id: 'm9_5',
        sender: 'contact',
        kab: 'Ad d-ɛeddiɣ tura kan, tebɣiḍ ad k-ɛawneɣ deg kra ?',
        fr: 'Je passe tout de suite, t\'as besoin d\'aide pour un truc ?',
        time: '11:17',
      },
      {
        id: 'm9_6',
        sender: 'player',
        kab: 'Ala tanemmirt, yal wa ad iɛawen gma-s !',
        fr: 'Non merci, la solidarité entre voisins c\'est normal !',
        time: '11:19',
      },
      {
        id: 'm9_7',
        sender: 'contact',
        kab: 'A k-iḥrez Rebbi a gma, ad d-asɣeɣ lqahwa !',
        fr: 'Que Dieu te garde frérot, je ramène le café !',
        time: '11:20',
      },
      {
        id: 'm9_8',
        sender: 'player',
        kab: 'Ansuf yis-k melmi i d-tusiḍ !',
        fr: 'Bienvenue chez toi quand tu veux !',
        time: '11:22',
      },
    ],
  },
  {
    id: 'sms_tanina_study',
    title: 'Lemɛawna d Tanina',
    contactName: 'Tanina (Études)',
    contactRole: 'Révision & Cours',
    avatar: '📚',
    avatarBg: 'bg-indigo-100 border-indigo-300 text-indigo-900',
    themeTag: 'Études & Révisions',
    contextDesc: 'Entraide pour réviser les cours et préparer les examens ensemble.',
    messages: [
      {
        id: 'm10_1',
        sender: 'contact',
        kab: 'Azul ! Tebdiḍ aheggi n l\'examen n uzekka ?',
        fr: 'Salut ! T\'as commencé à réviser l\'examen de demain ?',
        time: '18:00',
      },
      {
        id: 'm10_2',
        sender: 'player',
        kab: 'Azul Tanina ! Ih, bdiɣ dros kan, mazal tamsirt tis snat.',
        fr: 'Salut Tanina ! Oui, un peu, il me reste la deuxième leçon.',
        time: '18:02',
      },
      {
        id: 'm10_3',
        sender: 'contact',
        kab: 'Tebɣiḍ ad nexdem deg la bibliothèque n l-fac neɣ s uselkim ?',
        fr: 'Tu veux qu\'on révise à la bibliothèque de la fac ou en visio ?',
        time: '18:04',
      },
      {
        id: 'm10_4',
        sender: 'player',
        kab: 'Ih d tikti tameqrant, ad nɛawed akk imagraden.',
        fr: 'Carrément, excellente idée, on reverra tous les chapitres.',
        time: '18:06',
      },
      {
        id: 'm10_5',
        sender: 'contact',
        kab: 'Melmi ara tebduḍ ? Nekk heggaɣ ikayaden.',
        fr: 'Tu commences quand ? Moi j\'ai préparé les fiches.',
        time: '18:08',
      },
      {
        id: 'm10_6',
        sender: 'player',
        kab: 'Deg ssetta ad d-lḥuɣ, ad d-greɣ awal deg ttilifun.',
        fr: 'À 18h je serai dispo, je t\'envoie un message.',
        time: '18:10',
      },
      {
        id: 'm10_7',
        sender: 'contact',
        kab: 'D ayen igerzen nezzeh, ad nrebḥ inshallah !',
        fr: 'Super alors, on va réussir inshallah !',
        time: '18:12',
      },
      {
        id: 'm10_8',
        sender: 'player',
        kab: 'Inshallah s lqewwa, ar tmeddit !',
        fr: 'Inshallah à fond, à tout à l\'heure !',
        time: '18:14',
      },
    ],
  },
  {
    id: 'sms_debbia_gossip',
    title: 'Ameslay d Debbia',
    contactName: 'Debbia (La Cousine)',
    contactRole: 'Potins & Rumeurs',
    avatar: '👀',
    avatarBg: 'bg-pink-100 border-pink-300 text-pink-900',
    themeTag: 'Commérages & Potins',
    contextDesc: 'Gros potins du village : fiançailles secrètes, histoires de famille et rumeurs croustillantes !',
    messages: [
      {
        id: 'm11_1',
        sender: 'contact',
        kab: 'Azul ! Tesliḍ i wayen yeḍran ass-a deg taddart ?',
        fr: 'Salut ! T\'as entendu ce qui s\'est passé aujourd\'hui au village ?',
        time: '20:10',
      },
      {
        id: 'm11_2',
        sender: 'player',
        kab: 'Azul Debbia ! Ala, d acu yeḍran ? Mel-iyi-d kan !',
        fr: 'Salut Debbia ! Non, qu\'est-ce qui s\'est passé ? Raconte-moi vite !',
        time: '20:12',
      },
      {
        id: 'm11_3',
        sender: 'contact',
        kab: 'Muḥend n Ɛmer ixeṭṭeb weltma-s n Faḍma s tuffra !',
        fr: 'Mohand de chez Amar s\'est fiancé avec la sœur de Fadma en secret !',
        time: '20:14',
      },
      {
        id: 'm11_4',
        sender: 'player',
        kab: 'Welleh ? Ur ttamneɣ ara, nnan-d yakan ur tt-iḥemmel ara !',
        fr: 'C\'est vrai ? J\'y crois pas, ils disaient pourtant qu\'il ne l\'aimait pas !',
        time: '20:16',
      },
      {
        id: 'm11_5',
        sender: 'contact',
        kab: 'Ih ! Yemma-s tessusem, ur tebɣi ara ad slen medden.',
        fr: 'Oui ! Sa mère a gardé le silence, elle ne voulait pas que les gens sachent.',
        time: '20:18',
      },
      {
        id: 'm11_6',
        sender: 'player',
        kab: 'Lɣaci akk deg l-ḥuma d les réseaux ad d-mmeslayen !',
        fr: 'Tout le monde dans le quartier et sur les réseaux va en parler !',
        time: '20:20',
      },
      {
        id: 'm11_7',
        sender: 'contact',
        kab: 'Waqila ad xedmen tameɣra meqqren deg unebdu.',
        fr: 'Apparemment ils vont faire un mariage géant cet été.',
        time: '20:22',
      },
      {
        id: 'm11_8',
        sender: 'player',
        kab: 'Ayen yelhan ihi, ad nṛuḥ ad nečč seksu !',
        fr: 'Tant mieux alors, on ira manger du bon couscous !',
        time: '20:24',
      },
    ],
  },
  {
    id: 'sms_idir_anecdotes',
    title: 'Tidyanin d Idir',
    contactName: 'Idir (Pote d\'enfance)',
    contactRole: 'Souvenirs & Fous rires',
    avatar: '😂',
    avatarBg: 'bg-orange-100 border-orange-300 text-orange-900',
    themeTag: 'Anecdotes & Rires',
    contextDesc: 'Fous rires et souvenirs croustillants d\'une gaffe mémorable lors d\'un mariage.',
    messages: [
      {
        id: 'm12_1',
        sender: 'contact',
        kab: 'Tcfiḍ asmi i d-yeɣli Akli deg tmeɣra n Weɛli ?',
        fr: 'Tu te rappelles quand Akli est tombé pendant le mariage de Louali ?',
        time: '21:30',
      },
      {
        id: 'm12_2',
        sender: 'player',
        kab: 'Ahaha ih tcfiɣ, yeṭṭef ṭṭbel yerna yeɣli deg umḍiq n seksu !',
        fr: 'Hahaha oui je me rappelle, il tenait le tambour et il a glissé dans le couscous !',
        time: '21:32',
      },
      {
        id: 'm12_3',
        sender: 'contact',
        kab: 'Kullec yeččur d lmerqa, imeddukkal akk ttḍusun !',
        fr: 'Tout était plein de sauce, tous les potes étaient morts de rire !',
        time: '21:34',
      },
      {
        id: 'm12_4',
        sender: 'player',
        kab: 'Ula d yemma-s tebda teṭṭeḍsa zdat n medden.',
        fr: 'Même sa propre mère s\'est mise à rigoler devant tout le monde.',
        time: '21:36',
      },
      {
        id: 'm12_5',
        sender: 'contact',
        kab: 'Yerna yefka-d asurif ameqran iwakken ad yerwel !',
        fr: 'En plus il a fait un grand saut pour essayer de s\'enfuir !',
        time: '21:37',
      },
      {
        id: 'm12_6',
        sender: 'player',
        kab: 'Ur nexdim ara am netta ass-a, mazal-aɣ d imdukkal !',
        fr: 'On n\'en refera plus des comme ça, heureusement qu\'on est toujours potes !',
        time: '21:39',
      },
      {
        id: 'm12_7',
        sender: 'contact',
        kab: 'Azekka ad nemlil deg la pizzeria tamaynut ad nɛawed tidyanin-nni.',
        fr: 'Demain on se capte à la nouvelle pizzeria pour se remémorer ces histoires.',
        time: '21:40',
      },
      {
        id: 'm12_8',
        sender: 'player',
        kab: 'Ih d ayen igerzen, ad nečč lqahwa s teḍsa !',
        fr: 'Carrément trop bien, on va bien rigoler autour d\'un café !',
        time: '21:42',
      },
    ],
  },
  {
    id: 'sms_hocine_breaking',
    title: 'Lexbar d Dda Ḥusin',
    contactName: 'Dda Ḥusin (Le Voisin)',
    contactRole: 'Faits Divers & Ville',
    avatar: '🐗',
    avatarBg: 'bg-red-100 border-red-300 text-red-900',
    themeTag: 'Faits Divers & Alerte',
    contextDesc: 'Alerte insolite : un sanglier descendu de la colline a déboulé en pleine station-service et sur le rond-point !',
    messages: [
      {
        id: 'm13_1',
        sender: 'contact',
        kab: 'Tesliḍ s wayen yeḍran deg le rond-point ameqran ?',
        fr: 'T\'as entendu ce qui est arrivé au grand rond-point ?',
        time: '22:05',
      },
      {
        id: 'm13_2',
        sender: 'player',
        kab: 'Ala a Dda Ḥusin ! D acu i yeḍran daɣen ?',
        fr: 'Non Dda Hocine ! Qu\'est-ce qui s\'est encore passé ?',
        time: '22:07',
      },
      {
        id: 'm13_3',
        sender: 'contact',
        kab: 'Yiwen yilef ameqran yekcem armi d la station-service !',
        fr: 'Un énorme sanglier a déboulé jusqu\'à la station-service !',
        time: '22:09',
      },
      {
        id: 'm13_4',
        sender: 'player',
        kab: 'Ilef deg la station-service ? Amek armi i d-yeṣṣaweḍ armi d dinna ?',
        fr: 'Un sanglier à la station-service ? Comment il a pu arriver jusqu\'à là-bas ?',
        time: '22:11',
      },
      {
        id: 'm13_5',
        sender: 'contact',
        kab: 'Yekka-d seg tiẓgi, yuzzel zdat l-parking yerna yexleɛ lɣaci !',
        fr: 'Il a surgi de la forêt, a foncé devant le parking et a fait paniquer tout le monde !',
        time: '22:13',
      },
      {
        id: 'm13_6',
        sender: 'player',
        kab: 'Yella win i yuɣen lḥal neɣ yufa tura abrid-is ?',
        fr: 'Quelqu\'un a été blessé ou bien il a fini par s\'enfuir ?',
        time: '22:15',
      },
      {
        id: 'm13_7',
        sender: 'contact',
        kab: 'Ulac win yuɣ lḥal, rran-t medden ɣer tebḥirin n beṛṛa.',
        fr: 'Personne n\'a rien eu, les gens l\'ont repoussé vers les champs extérieurs.',
        time: '22:17',
      },
      {
        id: 'm13_8',
        sender: 'player',
        kab: 'Lḥemdulilah ! D lmerra tamezwarut i nezra aya !',
        fr: 'Dieu merci ! C\'est la première fois qu\'on voit un truc pareil !',
        time: '22:19',
      },
    ],
  },
  {
    id: 'sms_numidya_conflict',
    title: 'Zɛaf d Numidya',
    contactName: 'Numidya (La Copine)',
    contactRole: 'Couple & Tensions',
    avatar: '💔',
    avatarBg: 'bg-rose-100 border-rose-300 text-rose-900',
    themeTag: 'Couple & Dispute',
    contextDesc: 'Tension dans le couple : messages ignorés, retard inexpliqué et explications houleuses par SMS.',
    messages: [
      {
        id: 'm14_1',
        sender: 'contact',
        kab: 'Acḥal aya i k-ttraǧuɣ ! Acuɣer ur d-tterreḍ ara deg ttilifun ?',
        fr: 'Ça fait des heures que je t\'attends ! Pourquoi tu ne réponds pas au téléphone ?',
        time: '19:40',
      },
      {
        id: 'm14_2',
        sender: 'player',
        kab: 'Smeḥ-iyi, lliɣ deg uxeddim, ṭṭfeɣ aṭas ur ẓriɣ ara asiwel-im.',
        fr: 'Pardonne-moi, j\'étais au travail, j\'étais débordé et je n\'ai pas vu ton appel.',
        time: '19:42',
      },
      {
        id: 'm14_3',
        sender: 'contact',
        kab: 'Yal tikelt d yiwet n ssebba ! Twalaḍ izen-iw yerna tsusmeḍ !',
        fr: 'À chaque fois c\'est la même excuse ! Tu as vu mon message et tu n\'as pas répondu !',
        time: '19:44',
      },
      {
        id: 'm14_4',
        sender: 'player',
        kab: 'Ur zɛef ara fell-i, ur nwiɣ ara akk ad kem-sḥezneɣ !',
        fr: 'Ne sois pas fâchée contre moi, je ne voulais surtout pas te peiner !',
        time: '19:46',
      },
      {
        id: 'm14_5',
        sender: 'contact',
        kab: 'Nnan-iyi-d yakan telliḍ deg la cafétéria d yimeddukkal-ik !',
        fr: 'On m\'a pourtant dit que tu étais posé à la cafétéria avec tes potes !',
        time: '19:48',
      },
      {
        id: 'm14_6',
        sender: 'player',
        kab: 'D lekdeb kan, ɣliɣ deg lxedma d uɛewweq armi d tura !',
        fr: 'C\'est des bêtises, j\'étais coincé sous le boulot et les galères jusqu\'à maintenant !',
        time: '19:50',
      },
      {
        id: 'm14_7',
        sender: 'contact',
        kab: 'Ḥusseɣ am akken ur iyi-tefkiḍ ara azal am zik...',
        fr: 'J\'ai l\'impression que tu ne m\'accordes plus autant d\'importance qu\'avant...',
        time: '19:52',
      },
      {
        id: 'm14_8',
        sender: 'player',
        kab: 'Teẓriḍ ḥemmleɣ-kem nezzeh, ad d-aseɣ tura ɣur-m ad nqeṣṣer !',
        fr: 'Tu sais que je t\'aime énormément, je viens tout de suite chez toi pour qu\'on parle !',
        time: '19:54',
      },
    ],
  },
  {
    id: 'sms-rencontre-bretagne-kabylie',
    title: 'Aksil & Yannick',
    contactName: 'Yannick & Aksil',
    contactRole: 'Amis (Rencontre)',
    avatar: '🌍',
    avatarBg: 'bg-blue-100 border-blue-300 text-blue-900',
    themeTag: 'Présentation & Amitié',
    contextDesc: 'Apprendre à se connaître entre la Bretagne et la Kabylie !',
    messages: [
      {
        id: 'msg-breizh-1',
        sender: 'contact',
        kab: 'Azul ! Nekk d Yannick. Isem-iw Yannick, d afransis, luleɣ deg tmurt n Bretagne (Bṛeṭaɲ). I kečč ?',
        fr: "Salut ! Moi c'est Yannick. Mon nom est Yannick, je suis français, je suis né en Bretagne. Et toi ?",
        time: '14:00',
      },
      {
        id: 'msg-breizh-2',
        sender: 'player',
        kab: 'Azul a Yannick ! Isem-iw Aksil. Nekk d aqbayli, zedɣeɣ deg tmurt n Leqbayel, deg twilayt n Tizi Wezzu.',
        fr: "Salut Yannick ! Mon nom est Aksil. Je suis Kabyle, j'habite en Kabylie, dans la wilaya de Tizi Ouzou.",
        time: '14:02',
      },
      {
        id: 'msg-breizh-3',
        sender: 'contact',
        kab: 'Amek tella tmurt-ik ? Bṛeṭaɲ d tamurt yelhan nezzeh, teččur d amezruy, s yiri n yilel awḥiḍ, timucuha tiqburin d tudrin icebḥen.',
        fr: "Comment est ton pays ? La Bretagne est magnifique, pleine d'histoire, avec ses côtes sauvages, ses vieilles légendes et ses beaux villages.",
        time: '14:05',
      },
      {
        id: 'msg-breizh-4',
        sender: 'player',
        kab: 'Ula d tamurt n Leqbayel d tamurt n umezruy d yidles. D tamurt n uzemmur, n tmedyazt taqburt, akked tudrin yersan ɣef yidurar ɛlayen.',
        fr: "La Kabylie est aussi riche en histoire et en culture. C'est le pays des oliviers, de la poésie ancienne, et des villages perchés sur de hautes montagnes.",
        time: '14:07',
      },
      {
        id: 'msg-breizh-5',
        sender: 'contact',
        kab: 'Igerrez ! D acu i tḥemmleḍ ad txedmeḍ deg wass-ik ?',
        fr: "C'est super ! Qu'est-ce que tu aimes faire de tes journées ?",
        time: '14:10',
      },
      {
        id: 'msg-breizh-6',
        sender: 'player',
        kab: 'Ḥemmleɣ ad lḥuɣ deg wedrar, ad ɣreɣ idlisen, yerna ḥemmleɣ ad ččeɣ seksu akked tjellabaṭ !',
        fr: "J'aime marcher dans la montagne, lire des livres, et j'aime manger du couscous avec des petits pois !",
        time: '14:12',
      },
      {
        id: 'msg-breizh-7',
        sender: 'contact',
        kab: 'Ah! Nekk ḥemmleɣ ad ččeɣ "les crêpes" d "les galettes". Acu-t lxedma-k ?',
        fr: "Ah ! Moi j'aime manger des crêpes et des galettes. Quel est ton métier ?",
        time: '14:15',
      },
      {
        id: 'msg-breizh-8',
        sender: 'player',
        kab: 'Nekk d aselmad. Sselmadeɣ tutlayt taqbaylit. I kečč ?',
        fr: "Moi je suis professeur. J'enseigne la langue kabyle. Et toi ?",
        time: '14:17',
      },
      {
        id: 'msg-breizh-9',
        sender: 'contact',
        kab: 'Nekk d aneḍḍam (informaticien). Tura bɣiɣ ad issineɣ taqbaylit akken ilaq. Tzemreḍ ad iyi-tɛawneḍ ?',
        fr: "Moi je suis informaticien. Maintenant je veux connaître le kabyle comme il faut. Tu peux m'aider ?",
        time: '14:20',
      },
      {
        id: 'msg-breizh-10',
        sender: 'player',
        kab: 'Ih, s lferḥ ! Ad ak-d-azneɣ awalen yal ass.',
        fr: "Oui, avec joie ! Je t'enverrai des mots chaque jour.",
        time: '14:22',
      }
    ]
  }
];
